<template>
  <div class="titleStyle">
    <span>{{txt}}</span>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    txt: {
      type: String,
      default: "选择数据集"
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.titleStyle {
  width: 100%;
  display: flex;
  flex-direction: column;
  span {
    font-size: 16px;
    color: #2f4061;
  }
  div {
    margin-top: 15px;
    width: 100%;
    border: 1px solid #ebedf0;
  }
}
</style>